import mod from "-!./Venta.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Venta.js?vue&type=script&lang=js&"